<template>
  <div class="accessdenied">
    <div class="img"></div>
    <p class="text">暂无权限</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.accessdenied {
  height: 100%;
  .img {
    padding-top: 50px;
    height: 220px;
    background: url(../assets/images/limit.png) no-repeat center bottom;
  }
  .text {
    text-align: center;
    margin-top: 20px;
    color: #999;
    font-size: 18px;
  }
}
</style>
